import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
export default function CardmsgA({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_pro_new');

    return (
        <div className={`${css.cardmsgA} cardmsgA1 GtmModuleData-section`} data-section-id={css.cardmsgA} data-section-title={t('infinity_port')}>
            <div className="card-icon-msg-box card-icon-msg-box1">
                <div className="msg-title1">
                    <div className="title-icon">
                        <Image src="/icons/mobileH5/TheInfinityPortIcon.svg" className="fullImgs" layout="fill" alt={t('infinity_port')} />
                    </div>
                    {t('infinity_port')}
                </div>
                <div className="msg-title2">
                    {t.rich('infinity_port_sub_title', {
                        line1: (child: string) => <div>{child}</div>,
                        line2: (child: string) => <div>{child}</div>,
                        line3: (child: string) => <div className="card-color-1">{child}</div>,
                    })}
                </div>
                <div className="msg-desc">{t('infinity_port_desc')}</div>
            </div>
        </div>
    );
}
